import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { DIMsgObj } from '../models/dimsgobj';
import { BusyCursor } from '../busycursor/busycursor';
import { ToastrMessage } from './toastr.message';
import { ListFactory } from '../caches/list.factory';
import { Router } from '@angular/router';
import { Repository } from 'src/app/modules/repository/repository';
import { CommonEnums } from '../common.enums';

@Injectable({
  providedIn: 'root'
})
export class HTTPClientService {
  listFactory: ListFactory;
  repository: Repository;

  constructor(private httpClient: HttpClient,
    public busyCursor: BusyCursor,
    private toastrMessage: ToastrMessage,
    private router: Router) {
    this.listFactory = ListFactory.getInstance();
    this.repository = Repository.getInstance();
  }

  get(url: string, showBusyCursor: boolean = false, skipCodes: Array<string> = new Array<string>(),
    handleError: boolean = true, canEscape: boolean = false) {
    console.log('getObjects: ' + url);

    if (showBusyCursor)
      this.busyCursor.incrementCount();

    return this.httpClient.get(url)
      .pipe(map(result => {
        if (showBusyCursor)
          this.busyCursor.decrementCount();

        let diMsgObj: DIMsgObj = result as DIMsgObj;

        if (diMsgObj.error_Cd != '0') {
          this.verify(diMsgObj, skipCodes);
          return diMsgObj;
        }

        console.log('return getObjects: ' + url);
        return diMsgObj;
      }),
        catchError(err => {
         if (showBusyCursor)
            this.busyCursor.decrementCount();

          let errorMessage = err?.error?.message || err?.message || 'Network error occurred';
          if (this.toastrMessage && this.toastrMessage.showErrorToastr) {
            this.toastrMessage.showErrorToastr(errorMessage);
          }

          return throwError(() => err);
        })
      );
  }

  post(url: string, object: any, showBusyCursor: boolean = false,
    handleError: boolean = false, skipCodes: Array<string> = [], canEscape: boolean = false) {
    console.log('postObjects: ' + url);

    if (showBusyCursor)
      this.busyCursor.incrementCount();

    return this.httpClient.post(url, object)
      .pipe(map(result => {
        if (showBusyCursor)
          this.busyCursor.decrementCount();

        let diMsgObj: DIMsgObj = result as DIMsgObj;

        if (diMsgObj.error_Cd != "0") {
          // When handleError is true the caller takes responsibility for
          // showing a user-friendly message; skip the raw auto-toast.
          if (!handleError) {
            this.verify(diMsgObj, skipCodes);
          }
          return diMsgObj;
        }

        console.log('return postObjects: ' + url);
        return diMsgObj;
      }),
       catchError(err => {
        if (showBusyCursor)
          this.busyCursor.decrementCount();

        let errorMessage = err?.error?.message || err?.message || 'Connection failed';

        if (this.toastrMessage && this.toastrMessage.showErrorToastr) {
          this.toastrMessage.showErrorToastr(errorMessage);
        } else {
          console.error('Error:', errorMessage);
        }

        return throwError(() => err);
      })
    );
    }

  verify(diMsgObj: DIMsgObj, skipCodes: Array<string>): void {
    if (skipCodes &&
      skipCodes.indexOf(diMsgObj.error_Cd) != -1) {
      return;
    }

    console.log(diMsgObj.error_Msg);

     if (diMsgObj.error_Cd === 'EFA00003' || diMsgObj.error_Cd === 'EFA00008') {
      if (this.toastrMessage && this.toastrMessage.showErrorToastr) {
        this.toastrMessage.showErrorToastr(diMsgObj.error_Msg || 'Connection failed');
      }
      return;
    }

    switch (diMsgObj.error_Cd) {
      case 'ESM00016': // session exists
      case 'ESM00114':
        return;
      /*if( EmptyObjectsFactory.loginObject.ssoFlg == 'Y') return false;*/
      // $rootScope.hideOkta = true;
      // $rootScope.$broadcast('OPEN_LOGIN_FORCIBLE_POPUP_EVENT', diMsgObj);
      // return false;
      case 'ESM00014':
        // if (this.router.url.indexOf('login') == -1)
        // this.listFactory.showSessionExpiredPopup();
        return;

      case 'ESM00021':
        //   this.listFactory.forcibleDeleteErrorMsg = diMsgObj.error_Cd + ':' + diMsgObj.error_Msg;
        // this.listFactory.showForcebleDeletePopup();
        return
      case 'ESM00690':
        return;

      case 'ESM00041':
        return;
      case 'ESM00080':
        return;
      case 'ESM00159':
        return;
      // $rootScope.$broadcast('OPEN_ALERT_POPUP_EVENT', diMsgObj.error_Msg, "Message", "info");
      // return false;

      case 'ESM00013':
        if (this.repository.change_Ind == CommonEnums.change_Ind.CHANGED || this.repository.change_Ind == CommonEnums.change_Ind.CREATED) {
          return;
        }

      case 'EFA00008':

      case 'ESM00061':
      //   this.listFactory.showForcebleDeletePopup();
      // return
      // alert("Session expired, click Ok to relogin.");
      // this.router.navigateByUrl("session/login");

      case 'ESM00002':
      // UserSessionFactory.invalidLoginMsg = diMsgObj.error_Msg;

      // if (diMsgObj.error_Cd == 'ESM00013') {
      //   document.getElementById("data-ssoFlag").value = 'N';
      //   $rootScope.hideOkta = true;
      //   $rootScope.$broadcast('OPEN_ALERT_POPUP_EVENT', diMsgObj.error_Msg, "Error", "error2");

      //   if (diMsgObj.error_Msg.indexOf('project') != -1) {
      //     $rootScope.$broadcast('INVALID_PROJECT_REDIRECT_EVENT');
      //   }

      //   return false;
      // }
      // return false;
      case 'ESM00662':
      // $rootScope.$broadcast('OPEN_ALERT_POPUP_EVENT', diMsgObj.error_Msg, "Error", "error");
      // return false;
      case 'ESM00679':
      case 'ESM00684':
      // $rootScope.$broadcast('OPEN_DEPENDECY_POPUP_EVENT', diMsgObj.error_Msg, "Error", "error");
      // return false;
      case 'ESM00687':
      // $rootScope.$broadcast('DISABLE_REFRESH_LIST', diMsgObj.error_Cd + ': ' + diMsgObj.error_Msg, "Error", "error");
      // return false;
      case 'ESM00690':
      // $rootScope.$broadcast('OPEN_DATAPOINT_DEPENDECY_POPUP_EVENT', diMsgObj);
      // return false;
      case 'ESM11111':

      // return false;
      //$rootScope.invalidErrorMsg = diMsgObject.error_Msg;
      //$rootScope.isInvalidErrorMsgBoolean = true;

      //$rootScope.$broadcast('OPEN_ALERT_POPUP_EVENT', diMsgObject.error_Cd + ': ' + diMsgObject.error_Msg, "Error", "error");
      //$rootScope.$broadcast('orgInvalidMsg', diMsgObject);
      //  return false;

      case 'ESM00205':
        return;
    }

    // UserSessionFactory.invalidLoginMsg = diMsgObj.error_Msg;
    // $rootScope.$broadcast('OPEN_ALERT_POPUP_EVENT', diMsgObj.error_Cd + ': ' + diMsgObj.error_Msg, "Error", "error");

    // case 'EFA00003': test connection error

    //$rootScope.invalidErrorMsg = diMsgObject.error_Msg;
    //$rootScope.isInvalidErrorMsgBoolean = true;

    //$rootScope.$broadcast('OPEN_ALERT_POPUP_EVENT', diMsgObject.error_Cd + ': ' + diMsgObject.error_Msg, "Error", "error");

    // ESM00002 EPE00051 ESM999999 ESM00101 ESM00157 ESM00203 ESM00001 ESM00192
    // ESM00012 ESM00206 ESM00167 ESM99999 ESM00074 ESM00069 ESM00072
    // ESM00209 EFA00003 EFA00008 ESM00214 ESM00002

    //  return false;

    this.toastrMessage.showError_MsgToastr(diMsgObj.error_Cd, diMsgObj.error_Msg);
  };

  getPlainObjects(url: string, showBusyCursor: boolean = false) {

  }

  loginService(url: string, object: any, showBusyCursor: boolean = false) {
    console.log('postObjects: ' + url);

    if (showBusyCursor)
      this.busyCursor.incrementCount();

    return this.httpClient.post(url, object)
      .pipe(map(result => {
        if (showBusyCursor)
          this.busyCursor.decrementCount();

        let diMsgObj = result as DIMsgObj;

        if (diMsgObj.error_Cd != "0") {
          return diMsgObj;
        }

        console.log('return postObjects: ' + url);
        return diMsgObj;
      }));
  }

  getRaw(url: string, showBusyCursor: boolean = false, showErrorToastr: boolean = true) {
  if (showBusyCursor) {
    this.busyCursor.incrementCount();
  }

  return this.httpClient.get(url).pipe(
    map(result => {
      if (showBusyCursor) {
        this.busyCursor.decrementCount();
      }

      return result;
    }),
    catchError(err => {
      if (showBusyCursor) {
        this.busyCursor.decrementCount();
      }

      const errorMessage =
        err?.error?.message ||
        err?.message ||
        'Network error occurred';

      if (showErrorToastr && this.toastrMessage && this.toastrMessage.showErrorToastr) {
        this.toastrMessage.showErrorToastr(errorMessage);
      }

      return throwError(() => err);
    })
  );
}

}
